// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Cs8k","buttons":"Footer_buttons__3JaI7"};